"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MeetingActionItemRoleSchema () {
        return MeetingActionItemRoleSchema;
    },
    get MeetingActionItemStatusSchema () {
        return MeetingActionItemStatusSchema;
    },
    get MeetingActionItemsSchema () {
        return MeetingActionItemsSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _useractionrecord = require("../shared/user-action-record");
const MeetingActionItemStatusSchema = _zod.z.union([
    _zod.z.literal("complete"),
    _zod.z.literal("incomplete"),
    _zod.z.literal("deleted")
]).default("incomplete");
const MeetingActionItemRoleSchema = _zod.z.union([
    _zod.z.literal("assignee"),
    _zod.z.literal("assigner")
]);
/**
 * Represents a meeting associated with an action item and its status.
 * Action items can roll over and be associated with multiple meetings.
 * Providing the status at the meeting level allows for tracking the progress
 * of the action item across multiple meetings.
 **/ const MeetingWithStatusSchema = _zod.z.object({
    /** Foreign key - meeting document */ meeting_id: _zod.z.instanceof(_bson.ObjectId),
    status: MeetingActionItemStatusSchema,
    /** Display order within this meeting; absent until the list is first reordered */ position: _zod.z.number().int().nonnegative().optional()
});
/**
 * Represents a participant in an action item.
 * Anyone who plays a role in an action item is considered a participant.
 **/ const MeetingActionItemParticipantSchema = _zod.z.object({
    /** Foreign key - user document */ user_id: _zod.z.instanceof(_bson.ObjectId),
    role: MeetingActionItemRoleSchema
});
const MeetingActionItemsSchema = _base.BaseDocument.extend({
    name: _zod.z.string(),
    meetings: _zod.z.array(MeetingWithStatusSchema),
    participants: _zod.z.array(MeetingActionItemParticipantSchema),
    due_date: _zod.z.instanceof(Date).or(_zod.z.null()),
    created: _useractionrecord.UserActionRecord,
    updated: _useractionrecord.UserActionRecord
});
